import { Button, Stack, Typography } from '@mui/material'
import { IUser } from '~/@api/generated-api-types/global.types'
import { RowLabelValueIcon } from '~/@ui/row-label-value-icon/RowLabelValueIcon'

type Props = {
  user?: IUser | null
  logout: () => void
  chanePhone: () => void
}

export const UserProfile = ({ user, logout, chanePhone }: Props) => {
  return (
    <Stack>
      <Stack className="gap-4 px-6 mt-4">
        <Typography className="text-base font-bold text-zBlack200">
          Účet
        </Typography>
        <RowLabelValueIcon
          label="Tel. číslo"
          value={user?.phoneNumber ?? ''}
          editable
          handleEditClick={chanePhone}
        />
      </Stack>

      {(user?._personalInformation?._fullName ||
        user?._personalInformation?.address?.city ||
        user?._personalInformation?.address?.street ||
        user?._personalInformation?.address?.postalCode ||
        user?._personalInformation?.address?.country) && (
        <Stack className="gap-[11px] px-6 mt-8">
          <Typography className="text-base font-bold text-zBlack200">
            Osobné údaje
          </Typography>
          {user?._personalInformation?._fullName && (
            <RowLabelValueIcon
              label="Meno a priezvisko"
              value={user._personalInformation._fullName}
            />
          )}
          {user?._personalInformation?.address?.city && (
            <RowLabelValueIcon
              label="Mesto"
              value={user._personalInformation.address.city}
            />
          )}
          {user?._personalInformation?.address?.street && (
            <RowLabelValueIcon
              label="Adresa"
              value={user?._personalInformation.address.street}
            />
          )}
          {user?._personalInformation?.address?.postalCode && (
            <RowLabelValueIcon
              label="PSČ"
              value={user._personalInformation.address.postalCode}
            />
          )}
          {user?._personalInformation?.address?.country && (
            <RowLabelValueIcon
              label="Štát"
              value={user._personalInformation.address.country}
            />
          )}
        </Stack>
      )}

      <Stack className="items-start gap-1 px-6 mt-8">
        <Typography className="text-base font-bold text-zBlack200">
          Akcia
        </Typography>
        <Button
          variant="text"
          onClick={logout}
          className="text-3d font-medium text-zBlack200 underline">
          Odhlásiť sa
        </Button>
      </Stack>
    </Stack>
  )
}
